import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { ComponentProps, FC, useCallback } from 'react'
import { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'
import { FLOATING_PANE_AUTO_INVESTMENTS_MODE, FLOATING_PANE_CRYPTO_REWARDS_TYPE } from 'components/features/rewards/rewardsPane/constants/paneState'
import { CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_ENABLE } from 'components/features/rewards/rewardsPane/constants/paneSteps'
import Button from 'components/features/pfm/Button/Button'

type AutoinvestTurnOnButtonProps = {
  theme?: ComponentProps<typeof Button>['theme']
}
export const AutoinvestTurnOnButton: FC<AutoinvestTurnOnButtonProps> = (props) => {
  const { theme } = props
  const dispatch = useStoreDispatch()
  const openAutoinvestmentsPane = useCallback(() => {
    dispatch(new ModifyFloatingPaneAction({
      type: FLOATING_PANE_CRYPTO_REWARDS_TYPE,
      mode: FLOATING_PANE_AUTO_INVESTMENTS_MODE,
      step: CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_ENABLE,
      progressPercents: 20,
    }))
  }, [dispatch])

  return <Button theme={ theme } fullWidth onClick={ openAutoinvestmentsPane }>Turn on auto invest</Button>
}
